import { useContext } from "react";
import { Navigate } from "react-router-dom";
// import { UserAuthContext } from "./App";
import { UserAuthContext } from "./App";

const ProtectedRoute = ({ element, ...rest }) => {
  const { isLoggedIn } = useContext(UserAuthContext);

  return isLoggedIn ? element : <Navigate to="/login" />;
};
export default ProtectedRoute;

// import { Navigate, Outlet } from "react-router-dom";
// const ProtectedRoute = () => {
//   let auth = { token: true };
//   return auth.token ? <Outlet /> : <Navigate to="/login" />;
// };

// export default ProtectedRoute;
